import { OktaAuth, type OAuthResponseType } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import type { ReactNode } from 'react';

const oktaGcsAuth = new OktaAuth({
  issuer: 'https://okta.flytrex.com',
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/okta-callback`,
  scopes: ['openid', 'profile', 'email', 'groups'],
  responseType: 'code' as OAuthResponseType,
  pkce: false
});

type OktaSecurityProps = {
  restoreOriginalUri: (oktaAuth: OktaAuth, originalUri: string) => Promise<void>;
  children: ReactNode;
};

export function OktaSecurity({ restoreOriginalUri, children }: OktaSecurityProps) {
  return (
    <Security oktaAuth={oktaGcsAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
}
